export default "__VITE_ASSET__DbEC$Cci__"